import { provideEffects } from '@ngrx/effects';
import { provideState } from '@ngrx/store';

import { SurveyCreationAudienceEffects } from './state/audience/survey-creation-audience.effects';
import { SurveyCreationTemplateEffects } from './state/audience/survey-creation-template.effects';
import { SurveyCreationSaveEffects } from './state/audience/survey-creation-save.effects';
import { SurveyCreationAdvancedFiltersEffects } from './state/insights/survey-creation-advanced-filters.effects';
import { SurveyCreationInsightsEffects } from './state/insights/survey-creation-insights.effects';
import { SurveyCreationSimilarSurveyInsightEffects } from './state/insights/survey-creation-similar-survey-insight.effects';
import { SurveyCreationReferenceEffects } from './state/reference/survey-creation-reference.effects';
import { surveyCreationFeature } from './state/survey-creation.feature';

export const SURVEY_CREATION_STORE_PROVIDERS = {
  feature: provideState(surveyCreationFeature),
  effects: provideEffects(
    SurveyCreationAudienceEffects,
    SurveyCreationTemplateEffects,
    SurveyCreationSaveEffects,
    SurveyCreationInsightsEffects,
    SurveyCreationAdvancedFiltersEffects,
    SurveyCreationSimilarSurveyInsightEffects,
    SurveyCreationReferenceEffects,
  ),
};
